export default {
	global: {
		bookings: 'Reservaciones',
		rates: 'Tarifas',
		design: 'Diseño',
		settings: 'Configuración',
		successUpdate: 'Actualizado con exito',
		changeOf: 'Cambiar de {system}',
		clicToSwitch: 'Clic para cambiar a este {system}',
		changePlatform: 'Cambiar de plataforma',
		back: 'Atras',
		selectSystem: 'Seleccione un punto de venta',
		saveChanges: 'Guardar cambios',
		updatedConfigurations: 'Configuraciones actualizadas',
		transferTime: 'Tiempo de traslado',
		preFlightTime: 'Tiempo previo al vuelo:',

		close: 'Cerrar',
		open: 'Abrir',
		loading: 'Cargando...',

		operation: 'Operación',
		operationAssignment: 'Asignación',
		operationTracking: 'Operación en vivo',
		transportUnits: 'Unidades',
		users: 'Usuarios',
		drivers: 'Conductores',
		profile: 'Perfil',
		logout: 'Salir',
		all: 'Todos',
		selectAll: 'TODOS',
		clean: 'Limpiar',
		search: 'Buscar',
		firstName: 'Nombres',
		lastName: 'Apellidos',
		save: 'Guardar',
		yes: 'Si',
		filters: 'Filtros',
		registerDeleted: 'Borrado exitosamente',
		serverError: 'El servidor no responde',
		ajaxTable: {
			noRecordsFound: 'No se encontraron resultados',
			selectAll: 'Seleccionar todos',
			showingNRecords: 'Mostrando {from} a {to} registros de {total}',
			massiveOperationsOn: 'Habilitar operaciones masivas',
			massiveOperationsOff: 'Deshabilitar operaciones masivas',
			assignConfirmation: 'Asignar confirmación',
		},
		status: 'Estado',
		actions: 'Acciones',
		copy: 'Copiar',
		minutes: 'minutos',
		after: 'después',
		before: 'antes',
		ofFlight: 'del vuelo',
		delete: 'Eliminar',
		add: 'Agregar',
		phone: 'Teléfono',
		email: 'Correo electrónico',
		cancel: 'Cancelar',
		update: 'Actualizar',
		description: 'Descripción',
		change: 'Cambiar',
		upload: 'Subir',
		info: 'Información',
		image: 'Imagen',
		pos: 'PV',
		selectOption: 'Seleccione una opción',
		supplier: 'Proveedor',
		pointOfSale: 'Punto de venta',
	},
	warnings: {
		okToContinue: '¿Desea continuar con esta acción?',
		continue: 'Continuar',
		cancel: 'Cancelar',
		processing: 'Procesando',
		switchSystem: '¿Está seguro que desea cambiar de sistema?',
		selectValidSystem: 'Seleccione un sistema válido',
		wrongLogin: 'Usuario o contraseña incorrectos',
		forgetPassword: '¿Olvidó su contraseña?',
		errorOccurred: 'Ocurrió un error, intente más tarde',
		desactivateRate: '¿Desea desactivar esta tarifa?',
		noteRemoved: 'Nota eliminada',
		resCancelled: 'Reserva cancelada con éxito',
		noNegativeHours: 'No se pueden configurar horas negativas',

		offlinePOS: 'Su Punto de venta está offline, no puede agregar reservaciones.',
		liveUnverifiedEmail: 'Para cambiar el status, primero debes confirmar tu correo electrónico',
		changeStatusPOS: '¿Está seguro que desea cambiar el estado de su punto de venta? Esto podría afectar a las futuras reservaciones.',
	},
	bookings: {
		exporting: 'Exportando...',
		reservation: 'Reservación',
		reservationCreatedBy: 'Reserva creada por ',
		costs: 'Costos',
		notifications: 'Notificaciones',
		scheduleNotAvailable: 'El horario no está disponible',
		updated: 'Actualizado',
		showBilling: 'Mostrar información de facturación',
		billingInformation: 'IInformación de facturación',
		successNewReservation: 'La reservación se creó con éxito',
		alertCancelReservation: 'La reservación será <strong>cancelada</strong> y no será posible reactivarla de nuevo..',
		newNote: 'Nueva nota',
		statusEvidence: 'Evidencia de estado',
		evidence: 'Evidencia',
		flightValidatedBy: 'El vuelo ha sido validado por ',
		manualFlightValidation: 'Validación manual del vuelo',
		flightInfo: 'Datos del vuelo',
		flightNumberNotValid: 'Número de vuelo no válido',
		confirmedReservation: 'Reservación confirmada',
		editedReservation: 'Reservación editada',
		calculate: 'Calcular',
		serviceCreatedBy: 'Servicio creado por: ',
		contact: 'Contacto',
		paymentStatus: 'Estado del pago',
		clientNotes: 'Notas del cliente',
		serviceWillUpdateStatus: 'El servicio se actualizará al estado ',
		copyLink: 'Copiar url',
		passengers: 'Pasajeros',
		notAccepted: 'No aceptada',
		clientName: 'Nombre cliente',
		airports: 'Aeropuertos',
		general: 'General',
		destinations: 'Destinos',
		salesReference: 'ID canal de venta',
		supplierConfirmed: 'Servicio confirmado',
		referenceId: 'Confirmación Proveedor',
		serviceType: 'Tipo de servicio',
		serviceStatus: 'Estado de servicio',
		pickupConfirmed: 'Pickup confirmado',
		serviceDateFrom: 'Servicios desde',
		serviceDateTo: 'Servicios hasta',
		transportUnit: 'Unidad',
		driver: 'Conductor',
		trackingStatus: 'Estado de proceso',
		bookingDatetime: 'Fecha de reserva',
		bookingDateFrom: 'Fecha de reserva desde',
		bookingDateTo: 'Fecha de reserva hasta',
		serviceStatusOpts: {
			active: 'Activo',
			pending: 'Pendiente',
			noShow: 'No Show',
			noProvided: 'No atendido',
			canceled: 'Cancelado',
			done: 'Realizado',
			partialCancellation: 'Pre Cancelado',
		},
		trackingStatusOpts: {
			pending: 'Pendiente',
			onWayToPickup: 'Rumbo al origen',
			atPickup: 'En Origen',
			onWayToDropoff: 'Rumbo al destino',
			finished: 'Finalizado',
			noShow: 'No show',
		},
		reservationStatusOpts: {
			active: 'Activado',
			canceled: 'Cancelado',
		},
		confirmed: 'Confirmado',
		noConfirmed: 'No confirmado',
		cancelDateFrom: 'Fecha cancelación desde',
		cancelDateTo: 'Fecha cancelación hasta',
		tripType: 'Tipo de viaje',
		client: 'Cliente',
		pickupDate: 'Fecha pickup',
		trip: 'Viaje',
		actions: 'Acciones',
		export: 'Exportar',
		booking: 'Reservacion',
		clientInfo: 'Datos de cliente',
		adults: 'Adultos',
		kids: 'Niños',
		infants: 'Infantes',
		service: 'Servicio',
		status: 'Estado',
		origin: 'Origen',
		destination: 'Destino',
		route: 'Ruta',
		dateTimeAndNumberOf: 'Fecha, hora y numero de <strong>VUELO DE {flightLabel}</strong>',
		arrivalFlight: 'Vuelo llegada',
		departureFlight: 'Vuelo salida',
		pickupDatetime: 'Fecha y hora de pickup',
		confirmData: 'Confirmar datos',
		before: 'antes',
		after: 'despues',
		supplierNotes: 'Notas al proveedor',
		flight: 'vuelo',
		minutes: 'minutos',
		serviceUpdatedSuccessfully: 'Servicio actualizado con éxito',
		noShowEvidences: 'Evidencias de No Show',
		noShowEvidenceMessage: 'Para cambiar el estado del servicio a <strong>NO SHOW</strong>, por favor sube las pruebas correspondientes, que evidencien que el chófer y/o staff se encuentra en el tiempo y lugar programado.',
		doneEvidenceMessage: 'Para cambiar el estado del servicio a <strong>REALIZADO</strong>, por favor sube las pruebas correspondientes, que evidencien que el chófer y/o staff se encuentra en el tiempo y lugar programado.',
		accepted: 'Aceptado',
		shuttleCentralService: 'Venta de Shuttle Central',
		selfService: 'Servicio propio',
		rejectService: 'Rechazar servicio',
		notes: 'Notas',
		salesChannel: 'Canal de venta',
		salesChannelReference: 'Referencia canal de venta',
		noShow: 'No Show',
		noProvided: 'No atendido',
		cancel: 'Cancelar',
		done: 'Realizado',
		partialCancellation: 'Pre Cancelado',
		confirm: 'Confirmar',
		copyRes: 'Copiar reserva',
		createdBy: 'Creado por',
		reservationDate: 'Fecha de reservación',
		canceledBy: 'Cancelado por',
		cancelationDate: 'Fecha de cancelación',
		validate: 'Validar',
		addService: 'Agregar servicio',
		cancelRes: 'Cancelar reserva',
		acceptService: 'Aceptar servicio',
		servicesFrom: 'Servicios desde',
		servicesTo: 'hasta',
		clickFlightInfo: 'Clic para ver la información del vuelo',
		flightNotValidate: 'El vuelo no ha sido validado',
		newRes: 'Nueva reserva',
		paxes: 'Pasajeros',
		pickup: 'Origen',
		dropoff: 'Destino',
		transportInfo: 'Datos del servicio',
		makeBooking: 'Crear Reserva',
		Accepted: 'Servicios Confirmados',
		AcceptedOptions: {
			all: 'Todos',
			pending: 'Pendientes por confirmar',
			confirmed: 'Confirmados'
		},
		AcceptedOptionsMassive: {
			rejected: 'Rechazar',
			confirmed: 'Aceptar'
		},
		asignMsgPartial: "$TOTAL servicios no se pudieron actualizar ya que estaban previamente aceptados. Si requiere atencion adicional favor de contactar al personal de operaciones",
		asignMsg: 'Actualización exitosa',
		emptyStateSelect: 'No hay estado seleccionado',
		acceptReject: "Aceptar/Rechazar servicio",
		confirmAcceptService: "¿Estas seguro que desea ACEPTAR el servicio?",
		confirmRejectService: "¿Estas seguro que desea RECHAZAR el servicio?",
		selectServiceMassive: "Ningún servicio seleccionado",
		confirmSupplierConfirmationMassive: "¿Estas seguro que desea %{action} los servicios seleccionados?",
		assignDriverUnit: 'Asignación de conductor y vehículo',
		assign: 'Asignar',
		unassignedServices: 'Servicios NO ASIGNADOS',
		assignedServices: 'Servicios ASIGNADOS',
	},
	users: {
		resetPassword: "Restablecer la contraseña",
		newPassword : 'Nueva contraseña',
		repeatPassword : 'Repetir contraseña',
		updatedPassword : 'Contraseña actualizada',
		passwordAreDifferent : 'Contraseña son diferentes',
		newUser: 'Nuevo usuario',
		newDriver: 'Nuevo conductor',
		name: 'Nombre',
		email: 'Corre electrónico',
		access: 'Acceso',
		status: 'Estado',
		actions: 'Acciones',
		editingUser: 'Editando usuario',
		editingDriver: 'Editando conductor',
		firstName: 'Nombres',
		lastName: 'Apellidos',
		phone: 'Teléfono',
		userInfo: 'Información de usuario',
		language: 'Idioma',
		accessTypeOpts: {
			master: 'Maestro',
			admin: 'Administrador',
			operation: 'Operación',
			driver: 'Conductor',
		},
		license: 'Licencia',
		profilePicture: 'Foto de perfil',
		profile: 'Perfil',
		msgRegistered: 'Usuario agregado con éxito',
		msgUpdate: 'Usuario actualizado con éxito',
		msgRemoved: 'Usuario eliminado con éxito',
		password: 'Contraseña',
	},
	payments: {
		payments: 'Pagos',
		noPayment: 'No se ha realizado ningún pago para esta reserva.',
		totalReserve: 'Total de la reserva',
		totalPaid: 'Total pagado',
		totalPayable: 'Total a pagar',
		reference: 'Referencia de pago',
		cardHolder: 'Titular de la tarjeta',
		cardType: 'Tipo de tarjeta',
		last4: 'Últimos 4 dígitos',
		totalEngine: 'Total engine',
		total: 'Total',
		date: 'Fecha',
		status: 'Estado',
		currency: 'Moneda de pago',
		creationDateTime: 'Fecha',
		user: 'Usuario',

		selectCurrency: 'Seleccione la moneda',
		selectCurrencyDesc: 'Solo se podrán seleccionar los servicios que tengan esta moneda',
		expiredDate: 'Fecha de vencimiento',
		hour: 'Hora',
		serviceInAnotherPayReq: 'Este servicio esta seleccionado en otra solicitud de pago',
		serviceNumber: 'Numero de servicio',
		salesChannel: 'Canal de venta',
		tripType: 'Tipo de viaje',
		successPay: 'Se agregó correctamente el pago #',
		currencyReq: 'Moneda es requerido',
		expiredDateReq: 'Fecha y hora de expiración es requerido',
		serviceReq: 'Seleccione por lo menos un servicio',
		serviceAmountReq: 'Seleccione por lo menos un servicio con total mayor a 0',
		paymentStatus: 'Estado del pago',


		newPayment: 'Agregar pago',
		showDetails: 'Ver detalle',
		transactions: 'Transacciones',
		ridesToPay: 'Viajes a pagar',
		cancel: 'Cancelar',
		notifications: 'Notificaciones',
		copy: 'Copiar',
		goToLink: 'Ir a link de pago',
		hideDetails: 'Ocultar detalles',
		paymentForm: 'Formulario de pago',
		details: 'Detalles',
		id: 'Id',
		created: 'Creado',
		expiration: 'Expiración',
		sureCancelPayment: '¿Estas seguro que desea cancelar el pago #{paymentId}? No se podrá reactivar de nuevo',
		confirm: 'Confirmación',
		yes: 'Si',
		paymentCanceled: 'Se canceló correctamente el pago #',
		canceled: 'Cancelado',
		paid: 'Pagado',

		salesPrices: 'Precios venta',
		bookingPrice: 'Precio de la reserva',
		totalWithTaxes: 'Total c/imp',
		totalWithoutTaxes: 'Total s/imp',


	},
	profile: {
		firstName: 'Nombres',
		lastName: 'Apellidos',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		language: 'Idioma',
		changePassword: 'Cambiar contraseña',
		newPassword: 'Nueva contraseña',
		repeatPassword: 'Repetir contraseña',
		updatePassword: 'Actualizar contraseña',
		updatedPassword: 'Contraseña actualizada',
		passwordAreDifferent: 'Las contraseñas son diferentes',
		updatedData: 'Datos actualizados',
		changeSass: 'Cambiar de plataforma',
	},
	confirm: {
		Si: true,
		No: false
	},
	transportServiceChangeStatus: {
		note: 'Registra una nota*',
		btnUpdate: 'Actualizar servicio',
		btnUpdateProcess: 'Procesando',
		btnCancel: 'Cancelar',
		title: 'Evidencias de estado',
	},
	transportServiceStatus: {
		pending: 'Pendiente',
		active: 'Activo',
		noShow: 'No show',
		noProvided: 'No atendido',
		canceled: 'Cancelado',
		done: 'Realizado',
		success: 'Servicio actualizado con éxito',
		partialCancellation: 'Pre Cancelado',
	},
	filesRelated: {
		emptyImg: 'No se ha cargado imagenes',
		fileDelete: 'Archivo eliminado',
		notSelectImg: 'No has seleccionado una imagen',
		uploadedFile: 'Archivo cargado',
	},
	statusOptions: {
		active: 'Activo',
		pending: 'Pendiente'
	},
	statusActive: {
		active: 'Activo',
		inactive: 'Inactivo'
	},
	accessTypes: {
		master: 'Maestro',
		admin: 'Administrador',
		operation: 'Operación',
		driver: 'Conductor',
	},
	langOptions: {
		es: 'Español',
		en: 'Ingles',
	},
	alerts: {
		trackingStatusChanged: "El servicio: {serviceNumber} ha cambiado de status a: {trackingStatus} "
	},
	accessDenied: {
		accessDenied: 'Acceso denegado',
		expiredAccess: 'Ya no tiene acceso a este punto de venta, puede seleccionar otro para continuar',
		onlyOneAccess: 'Su usuario pertenece únicamente a este punto de venta',
	},
	login: {
		access: 'Acceder',
		wrongLogin: 'Usuario o contraseña incorrectos',
		forgetPassword: '¿Olvidó su contraseña?',
		recoverPassword: 'Recuperar contraseña',
		emailSent: 'Se ha enviado un correo electrónico, revise su bandeja de entrada. Para recuperar su contraseña, siga las instrucciones.',
		updatePassword: 'Actualizar contraseña',
		repeatPassword: 'Repetir contraseña',
		passwordAreDifferent: 'Las contraseñas no coinciden',
		passwordUpdated: 'Su contraseña ha sido actualizada',
		requestPasswordExpired: 'La solicitud de cambio de contraseña ha expirado',
	},
	design: {
		mediaPresentation: 'Fotos y presentación',
		headerLogo: 'Logotipo de la cabecera',
		footerLogo: 'Logotipo del pie de página',
		homeBanner: 'Banner de inicio',
		company: 'Empresa',
		publicName: 'Nombre público',
		publicNameDesc: 'Nombre a mostrar públicamente',
		showNewsletter: 'Mostrar boletín de noticias',
		colors: 'Colores',
		primaryColor: 'Color principal',
		primaryColorDesc: 'Color principal de texto e iconos',
		btnBackgroundColor: 'Color de botón',
		btnBackgroundColorDesc: 'Color de fondo del botón',
		btnForegroundColor: 'Color de fuente del botón',
		btnForegroundColorDesc: 'Color del texto de botón',
		backgroundColor: 'Color de fondo',
		backgroundColorDesc: 'Color de fondo general',
		example: 'Ejemplo:',
		bookHere: '¡Reserva aquí!',
	},
	taxInformation: {
		taxInformation: 'Facturación',
		company: 'Empresa',
		address: 'Dirección',
		city: 'Ciudad',
		country: 'País',
		postalCode: 'Código postal',

	},
	rates: {
		ratesDestinations: 'Destinos y tarifas',
		salesChannel: 'Canal de venta',
		area: 'Area',
		name: 'Nombre',
		currency: 'Moneda',
		action: 'Acciones',
		mapTitle: 'Visor de zonas',
		listTitle: 'Zonas de %{zone}',
		zoneTitle: 'Zona seleccionada: ',
		type: 'Tipo',
		active: 'Activo',
	},

	notifications: {
		send: 'Enviar',
		email: 'Correo electrónico',
		phone: 'Teléfono',
		lang: 'Idioma',
		changeLangClient: 'Cambiar el idioma del cliente en la reserva',
		template: 'Plantilla',
		selectOption: 'Seleccione una opción',
		previewSms: 'Vista previa del mensaje de texto',
		characters: 'Caracteres',
		wantToSendNotification: '¿Desea enviar la notificación?',
		emailWillSentTo: 'El email se enviará a ',
		smsWillSentTo: 'El sms se enviará a ',
		confirm: 'Confirmar',
		cancel: 'Cancelar',
		selectTemplate: 'Seleccione una plantilla',
		requiredTemplate: 'Notificacion a enviar es requerida',
		done: 'Realizado',
		verifyRequiredFields: 'Verifique los campos obligatorios',

		sendNewNotification: 'Enviar nueva notificación',
		sendNotification: 'Enviar notificación',
		id: 'ID del envío',
		status: 'Estado',
		creationDatetime: 'Fecha',
		user: 'Usuario',
		type: 'Tipo',
		notificationType: 'Tipo de notificación',
		dataSource: 'Data source',
		destination: 'Destino',

		// Mail verification notification
		notifications: 'Notificaciones',
		hasNotification: 'Hola, ¡tienes 1 notificación!',
		systemSc: 'Sistema Shuttle Central',
		confirmEmail: 'Confirmación de correo electrónico',
		confirmEmailBody: '<p>Hola {user}, por favor confirma tu correo electrónico para terminar la configuración de tu plataforma y aprovecharla al máximo.</p><p>Hemos enviado un correo electrónico a tu cuenta para la verificación.</p>',
		resendEmail: 'Reenviar correo',


	},

	quote: {
		assign: 'Asignar',
		title: 'Cotización/Venta',
		reservation: 'Reserva',
		newQuote: '/ Cotizar nueva reserva',
		currency: 'Moneda',
		tripType: 'Tipo de viaje',
		currencyReq: 'Moneda es requerido',
		pickupReq: 'Origen es requerido',
		dropoffReq: 'Destino es requerido',
		serviceTypeReq: 'Tipo de servicio es requerido',
		dateGoToReq: 'Fecha ida es requerido',
		dateGoBackReq: 'Fecha de regreso es requerido',
		adultsReq: 'Adultos es requerido',
		airportTransp: 'Transporte de aeropuerto',
		p2p: 'Punto a punto',

		oneWay: 'One way',
		return: 'Return',
	},

	tooltips: {
		viewRoute: 'Ver ruta en mapa',
		viewLocation: 'Ver ubicación en mapa',
		scadmin: 'Venta directa',
		be: 'Servicio creado desde el motor de reservas',
		statusPos: 'Su punto de venta está {status}. Haga clic para cambiarlo',
	},

	settings: {
		title: 'Configuración',
		save: 'Guardar cambios',
		contact: 'Contacto',
		legalName: 'Nombre legal',
		legalNameDesc: 'nombre legal de la empresa',
		website: 'Sitio web',
		websiteDesc: 'Ejemplo: misitioweb.com.mx',
		phone: 'Telefono contacto',
		phoneDesc: 'Los clientes lo contactarán mediante este número telefonico',
		mail: 'Correo notificaciones',
		mailDesc: 'A estos correos se le enviarán las notificaciones',
		addNewMail: 'Agregar correo adicional',
		socialMedia: 'Redes sociales',
		fbDesc: 'Como pueden encontrarlo vía Facebook',
		twDesc: 'Como pueden encontrarlo vía Twitter',
	},

	contact: {
		needHelp: '¿Necesita ayuda con el sistema?',
		sendWhats: 'Contactar vía WhatsApp',
		editBooking: '¿Desea editar una reservación?',
		openChat: 'Abrir chat',
		openChatDesc: 'Inicia el chat para recibir información y soporte.',
		defaultMsj1: 'Hola soy ',
		defaultMsj2: ' de ',
		defaultMsj3: ' y me gustaría recibir ayuda con el sistema admin.'
	},

	verifyEmail: {
		title: '¡Bienvenid@!',
		body: '<p class="mb-4">¡Gracias por unirte {user}! Estamos muy felices de que seas parte de Shuttle Central.</p> <p>Por favor, confirma tu correo electrónico para terminar la configuración de tu plataforma.</p>',
		clickToConfirm: 'Clic para confirmar',
		emailSent: 'Correo electrónico reenviado, revise su bandeja de entrada',
		confirmedTitle: '¡Correo confirmado!',
		confirmedBody: 'Gracias por confirmar tu correo electrónico, ¡regresemos al sistema!',
		goBack: 'Ir al sistema',
	}

}
